<template>
  <div class="jalali-calendar w-100">
    <!-- Input field -->

    <input
        v-if="!withOutInput"
        class="input-date"
        type="text"
        v-model="formattedDate"
        readonly
        @focus="openCalendar"
        @click="openCalendar"
        :placeholder="placeholder"
        v-click-outside="hidePopup"
    />


    <!-- Calendar Popup -->
    <div v-if="isCalendarVisible || withOutInput" class="calendar-popup" :class="{'position-relative':withOutInput}">
      <div class="calendar-header">
        <select v-model="selectedYear" @change="updateCalendar">
          <option v-for="year in years" :key="year" :value="year">
            {{ year }}
          </option>
        </select>
        <select v-model="selectedMonth" @change="updateCalendar">
          <option v-for="(month, index) in months" :key="index" :value="index + 1">
            {{ month }}
          </option>
        </select>
      </div>

      <!-- Days of the week -->
      <div class="weekdays">
        <div v-for="day in weekDays" :key="day">
          {{ day }}
        </div>
      </div>

      <!-- Calendar Days -->
      <div class="calendar-days">
        <!-- Empty slots for alignment -->
        <div
            v-for="n in firstDayOffset"
            :key="'empty-' + n"
            class="empty-day">
        </div>

        <!-- Days of the month -->
        <div
            v-for="day in daysInMonth"
            :key="day"
            class="day"
            :class="{ 'today': isToday(day), 'disabled': isDateDisabled(day), 'selected' : day === selectedDay && (withOutInput || withTime) }"
            :aria-disabled="isDateDisabled(day)"
            @click="selectDate(day)">
          {{ day }}
        </div>


      </div>
      <div v-if="withTime" class="time-picker">
        <span>ساعت</span>
        <select v-model="selectedHour" aria-label="hour">
          <option v-for="hour in hours" :key="hour" :value="hour">{{ hour }}</option>
        </select>
        <span>:</span>
        <select v-model="selectedMinute" aria-label="minute">
          <option v-for="minute in minutes" :key="minute" :value="minute">{{ minute }}</option>
        </select>
        <v-btn class="confirm-date-time" size="small" :disabled="!selectedDay" @click="confirmDateTime">
          تأیید
        </v-btn>
      </div>
      <div v-if="withOutInput && isNotTodaySelected" class="btns w-100 mt-4">
        <v-btn @click="goToToday" class="btn btn-is-today" variant="text">رفتن به امروز</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-jalaali";

export default {
  name: 'calandar_compoenent',
  props: {
    minDate: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: "تاریخ را انتخاب کنید"
    },
    valueNew: {
      type: String,
      default: null
    },
    withOutInput: {
      type: Boolean,
      default: false
    },
    withTime: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isCalendarVisible: false,
      selectedDate: null,
      selectedDay: '',
      selectedYear: moment().jYear(),
      selectedMonth: moment().jMonth() + 1,
      selectedHour: String(moment().hour()).padStart(2, '0'),
      selectedMinute: String(moment().minute()).padStart(2, '0'),
      daysInMonth: [],
      isNotTodaySelected: false,
      firstDayOffset: 0,
      years: Array.from({length: 20}, (_, i) => moment().jYear() - 10 + i),
      hours: Array.from({length: 24}, (_, i) => String(i).padStart(2, '0')),
      minutes: Array.from({length: 60}, (_, i) => String(i).padStart(2, '0')),
      months: [
        "فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور",
        "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"
      ],
      weekDays: ["ش", "ی", "د", "س", "چ", "پ", "ج"],
      today: moment(),
    };
  },

  computed: {
    formattedDate() {
      if (!this.selectedDate) return "";
      const value = this.toEnglishDigits(this.selectedDate);
      const format = this.withTime && /\s+\d{1,2}:\d{1,2}/.test(value) ? "jYYYY/jMM/jDD HH:mm" : "jYYYY/jMM/jDD";
      return this.toEnglishDigits(moment(value, format).format(format));
    },
  },
  methods: {
    isDateDisabled(day) {
      if (!this.minDate) return false;
      const date = moment(`${this.selectedYear}/${this.selectedMonth}/${day}`, 'jYYYY/jM/jD', 'en');
      const minimum = moment(this.toEnglishDigits(this.minDate), 'jYYYY/jM/jD', 'en');
      return date.isBefore(minimum, 'day');
    },
    hidePopup(el) {

      if (el.target.closest('.jalali-calendar') === null) {
        this.isCalendarVisible = false
      }

    },
    goToToday() {
      this.selectedYear = moment().jYear()
      this.selectedMonth = moment().jMonth() + 1
      this.selectDate(this.today.jDate())
      if (!this.withTime) this.selectedDay = ''
    },
    isToday(day) {
      return (
          this.selectedYear === this.today.jYear() &&
          this.selectedMonth === this.today.jMonth() + 1 &&
          day === this.today.jDate()
      );
    },
    openCalendar() {
      this.isCalendarVisible = true;
      if (this.selectedDate) this.syncFromValue(this.selectedDate);
      else this.updateCalendar();
    },
    updateCalendar() {
      this.selectedDay = ''
      const days = moment.jDaysInMonth(this.selectedYear, this.selectedMonth - 1);
      this.daysInMonth = Array.from({length: days}, (_, i) => i + 1);

      // Calculate the first day of the month for alignment
      const firstDay = moment(`${this.selectedYear}/${this.selectedMonth}/1`, "jYYYY/jMM/jDD").day();
      this.firstDayOffset = (firstDay + 1) % 7; // Adjust for Persian week (starting with Saturday)
    },
    selectDate(day) {
      if (this.isDateDisabled(day)) return;
      this.selectedDay = day
      this.selectedDate = `${this.selectedYear}/${this.selectedMonth}/${day}`;
      if (this.withTime) {
        this.$emit('date-selected', this.selectedDate);
        return;
      }
      this.isCalendarVisible = false;
      this.emitSelectedDate();
      let today = `${this.today.jYear()}/${this.today.jMonth() + 1}/${this.today.jDate()}`

      this.isNotTodaySelected = this.selectedDate !== today
    },
    confirmDateTime() {
      if (!this.selectedDay) return;
      const date = [this.selectedYear, this.selectedMonth, this.selectedDay]
          .map((value, index) => index === 0 ? value : String(value).padStart(2, '0'))
          .join('/');
      this.selectedDate = `${date} ${this.selectedHour}:${this.selectedMinute}`;
      this.isCalendarVisible = false;
      this.emitSelectedDate();
    },
    emitSelectedDate() {
      this.$emit("selected", this.selectedDate);
      this.$emit("selected2", this.selectedDate);
      this.$emit('input', this.selectedDate);
      this.$emit('update:modelValue', this.selectedDate);
    },
    syncFromValue(value) {
      this.selectedDate = value ? this.toEnglishDigits(value) : null;
      if (!value) return;
      const match = this.selectedDate.match(/^(\d{4})\/(\d{1,2})\/(\d{1,2})(?:\s+(\d{1,2}):(\d{1,2}))?/);
      if (!match) return;
      this.selectedYear = Number(match[1]);
      this.selectedMonth = Number(match[2]);
      this.selectedDay = Number(match[3]);
      if (match[4] !== undefined) this.selectedHour = String(match[4]).padStart(2, '0');
      if (match[5] !== undefined) this.selectedMinute = String(match[5]).padStart(2, '0');
      this.updateCalendar();
      this.selectedDay = Number(match[3]);
    },
    toEnglishDigits(value) {
      const persianDigits = '۰۱۲۳۴۵۶۷۸۹';
      const arabicDigits = '٠١٢٣٤٥٦٧٨٩';
      return String(value)
          .replace(/[۰-۹]/g, digit => persianDigits.indexOf(digit))
          .replace(/[٠-٩]/g, digit => arabicDigits.indexOf(digit))
    },
  },
  watch: {
    valueNew(newVal) {
      this.syncFromValue(newVal);
    }

  },
  mounted() {
    this.updateCalendar();
    this.syncFromValue(this.valueNew);
  },
};
</script>

<style scoped lang="scss">
.btn-is-today {
  font-size: 12px;
  border: 1px solid #ccc;
}

.jalali-calendar {
  position: relative;

  input {
    height: 100%;
    border: 1px solid #EDEEF1;
    border-radius: 99px;
    padding: 10px;
    width: 100%;
  }
}

.calendar-popup {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #D7DBE0;
  padding: 10px;
  z-index: 1000;
  border-radius: 15px;
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;

  select {
    width: 50%;
    padding: 5px 10px;
    cursor: pointer;
  }
}

.time-picker {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 12px;

  select {
    padding: 4px 6px;
    border: 1px solid #D7DBE0;
    border-radius: 6px;
  }

  .confirm-date-time {
    margin-right: 8px;
  }
}

.weekdays {
  margin-bottom: 15px;
}

.weekdays, .calendar-days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 5px;
}

.weekdays div {
  text-align: center;
  font-weight: bold;
}

.empty-day {
  visibility: hidden;
}

.day {
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #6C798B;
  font-size: 12px;
  cursor: pointer;
}

.day:hover {
  background: #f0f0f0;
}

.day.disabled {
  color: #cbd5e1;
  background: #f8fafc;
  cursor: not-allowed;
}

.day.today {
  background: #F07006;
  color: white;
  font-weight: bold;
  border-radius: 15px;
}

.day.selected {
  background: #0020b6;
  color: white;
  font-weight: bold;
  border-radius: 15px;
}
</style>
